function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './FilterButton.module.scss';
import FilterBox from '../FilterBox/FilterBox';
import cs from 'classnames';
import KEYCODES from '../../utils/KEYCODES';
export default function FilterButton(_ref) {
  var _ref$FilterBoxCompone = _ref.FilterBoxComponent,
    FilterBoxComponent = _ref$FilterBoxCompone === void 0 ? FilterBox : _ref$FilterBoxCompone,
    children = _ref.children,
    columnId = _ref.columnId,
    icons = _ref.icons,
    label = _ref.label;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var closeBox = useCallback(function () {
    return setExpanded(false);
  }, []);
  var boxRef = useRef(null);
  var buttonRef = useRef(null);
  function handleClick() {
    setExpanded(!expanded);
  }
  useEffect(function () {
    function handleDocumentClick(e) {
      var box = boxRef.current;
      var target = e.target;

      /**
       * The check for typeahead options list is due to issues with select fields
       * The typeahead select options are appended to the DOM when the select is expanded
       * so they're not actually contained within the filter box itself meaning once a selection is made
       * the box will close. There might be a better way to catch for this but checking for this class works
       * for now.
       */
      if (box && target && !box.contains(target) && !target.classList.contains('_dm-input--typeahead__option')) {
        closeBox();
      }
    }
    if (expanded) {
      document.addEventListener('click', handleDocumentClick, false);
    }
    return function () {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [closeBox, expanded]);
  function handleBoxBlur(e) {
    var relatedTarget = e.relatedTarget;
    var button = buttonRef.current;
    var box = boxRef.current;
    if (relatedTarget && relatedTarget !== button && button && !button.contains(relatedTarget) && box && !box.contains(relatedTarget)) {
      closeBox();
    }
  }
  function handleKeydown(e) {
    var button = buttonRef.current;
    e.stopPropagation();
    if (e.which === KEYCODES.ESC && button) {
      closeBox();
      button.focus();
    }
  }
  function handleButtonKeydown(e) {
    var button = buttonRef.current;
    e.stopPropagation();
    if (e.which === KEYCODES.ESC && button) {
      closeBox();
      button.focus();
    } else if (e.which === KEYCODES.TAB && e.shiftKey) {
      closeBox();
    }
  }
  function handleApply() {
    closeBox();
    var button = buttonRef.current;
    if (button) {
      button.focus();
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    id: "button-".concat(columnId),
    ref: buttonRef,
    "aria-controls": columnId,
    "aria-expanded": expanded,
    className: cs(styles.button, 'dm-table__header-button', 'dm-table__header-button--menu', 'auto-column-toggle'),
    onClick: handleClick,
    onKeyDown: handleButtonKeydown,
    type: "button"
  }, label, icons), /*#__PURE__*/React.createElement(FilterBoxComponent, {
    ref: boxRef,
    buttonRef: buttonRef,
    expanded: expanded,
    className: "dm-table__header-filter",
    id: columnId,
    onBlur: handleBoxBlur,
    onKeyDown: handleKeydown
  }, children(handleApply)));
}